import { PrinterOutlined } from '@ant-design/icons'
import { Button, Empty, Input, Pagination, Row, message } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { withRouter } from 'react-router-dom'
import AccessControlAction from '../../components/AccessControlAction'
import TableComponent from '../../components/Common/TableComponent'
import PageTitle from '../../components/PageTitle'
import AppPageHeader from '../../components/AppPageHeader'
import RefreshTrucButton from '../../components/TrucWrapper/RefreshTrucButton'
import TrucWrapper from '../../components/TrucWrapper/TrucWrapper'
import UnreadText from '../../components/UnreadText/UnreadText'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  OUTGOING_DOCUMENT_STATE,
  OUTGOING_DOCUMENT_STATUS,
} from '../../constants'
import DocumentsLayout from '../../layouts/DocumentsLayout/DocumentsLayout'
import utils from '../../utils'
import {
  SearchBar,
  TableFooterActionWrapper,
} from './ConnectedDocumentOutgoingDocPageStyled'

const { Search } = Input

const ConnectedDocumentOutgoingDocPage = props => {
  const {
    history,
    connectedDocumentStore,
    loadingAnimationStore,
    authenticationStore,
  } = props

  const { trucToken } = authenticationStore

  const {
    outgoingDocumentList,
    outgoingDocumentListTotalCount,
    outgoingDocumentListPageIndex,
    outgoingDocumentListPageSize,
    outgoingDocumentListFilterBySubject,
    setOutgoingDocumentListAllFilterBySubject,
    getOutgoingDocumentAll,
  } = connectedDocumentStore

  const NGAY_GUI_WIDTH = 120
  const SO_VAN_BAN_WIDTH = 150
  const TRICH_YEU_WIDTH = 350
  const SCROLL_WIDTH = 1000

  let [searchOptionTitle, setSearchOptionTitle] = useState('')

  const [exportLoading, setExportLoading] = useState(false)

  const getStatusText = ({ state }) => {
    if (OUTGOING_DOCUMENT_STATE[state]) {
      return OUTGOING_DOCUMENT_STATE[state].value
    } else {
      return OUTGOING_DOCUMENT_STATUS.SEND.value
    }
  }

  const tableColumns = [
    {
      title: 'Ngày gửi',
      width: NGAY_GUI_WIDTH,
      render: record => (
        <UnreadText
          text={moment(record.createdAt).format(DATE_FORMAT_DEFAULT)}
          isUnread={checkUnread(record)}
          width={NGAY_GUI_WIDTH}
        />
      ),
    },
    {
      title: 'Số văn bản',
      width: SO_VAN_BAN_WIDTH,
      render: record => (
        <UnreadText
          text={record.code}
          isUnread={checkUnread(record)}
          width={SO_VAN_BAN_WIDTH}
        />
      ),
    },
    {
      title: 'Trích yếu',
      width: TRICH_YEU_WIDTH,
      render: record =>
        record.subject ? (
          <UnreadText
            text={record.subject}
            isUnread={checkUnread(record)}
            width={TRICH_YEU_WIDTH}
          />
        ) : (
          <i style={{ color: '#ccc' }}>Không có trích yếu</i>
        ),
    },
    {
      title: 'Trạng thái',
      width: 100,
      render: record =>
        record.state ? (
          <UnreadText
            text={getStatusText(record)}
            isUnread={checkUnread(record)}
            width={100}
          />
        ) : (
          <i style={{ color: '#ccc' }}>-</i>
        ),
    },
  ]

  const checkUnread = record => !record.isViewed

  const exportDocument = useCallback(() => {
    setExportLoading(true)
    setOutgoingDocumentListAllFilterBySubject(
      searchOptionTitle && searchOptionTitle.trim()
    )

    const col = ['Ngày nhận', 'Số hiệu', 'Trích yếu']

    let rows = []
    rows.push(col)
    getOutgoingDocumentAll()
      .then(res => {
        if (res && res.data && res.data.data) {
          res.data.data.map(item => {
            rows.push([
              moment(item.createdAt).format(DATE_FORMAT_DEFAULT),
              item.code,
              item.subject,
              item.userFrom,
            ])
          })
        }
        utils.exportExcel(
          rows,
          'VBLT-VIMC - VB đi - ' + moment().format('YYYY-MM-DD hmms')
        )
      })
      .finally(() => setExportLoading(false))
  }, [searchOptionTitle])

  useEffect(() => {
    if (!localStorage.getItem('jwtTruc')) return
    loadingAnimationStore.showSpinner(true)
    connectedDocumentStore
      .getOutgoingDocument()
      .catch(err => {
        message.warning(err.vi)
      })
      .finally(() => loadingAnimationStore.showSpinner(false))
  }, [
    outgoingDocumentListPageIndex,
    outgoingDocumentListPageSize,
    outgoingDocumentListFilterBySubject,
    trucToken,
  ])

  return (
    <TrucWrapper>
      <DocumentsLayout
        title={
          <AppPageHeader
            title="Văn bản đi"
            addon={
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <Search
                  size="large"
                  className="rounded-search"
                  style={{ width: 300 }}
                  allowClear
                  onSearch={
                    connectedDocumentStore.setOutgoingDocumentListFilterBySubject
                  }
                  placeholder={'Tìm kiếm văn bản theo trích yếu'}
                  onChange={e => {
                    setSearchOptionTitle(e.target.value)
                  }}
                  value={searchOptionTitle}
                />
                <Button size="large" loading={exportLoading} onClick={exportDocument}>
                  <PrinterOutlined />
                  In
                </Button>
                <RefreshTrucButton />
                <AccessControlAction
                  aclActionType={ACL_ACTION_TYPE.create__LIEN_THONG_OUTGOING}>
                  <Button
                    size="large"
                    onClick={() => {
                      connectedDocumentStore.clearDataReceiveDocument()
                      history.push('/connected-document/outgoing-document/create')
                    }}
                    type={'primary'}>
                    Tạo mới văn bản đi
                  </Button>
                </AccessControlAction>
              </div>
            }
          />
        }
        selectedKey="outgoing-document"
        linkToIncomingDocument="/connected-document/incoming-document"
        linkToOutgoingDocument="/connected-document/outgoing-document">
        <Helmet>
          <title>Văn bản đi | Liên thông văn bản</title>
        </Helmet>
        <TableComponent
          onRow={record => {
            return {
              onClick: () =>
                history.push(
                  `/connected-document/outgoing-document/view/${record.id}`
                ),
            }
          }}
          rowKey={record => record.id}
          dataSource={outgoingDocumentList}
          columns={tableColumns}
          pagination={false}
          scroll={{ x: SCROLL_WIDTH }}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={'Không có dữ liệu'}
              />
            ),
          }}
        />
        <TableFooterActionWrapper>
          <Pagination
            onChange={e =>
              connectedDocumentStore.changeOutgoingDocumentPageIndex(e)
            }
            pageSize={outgoingDocumentListPageSize}
            showSizeChanger={false}
            showLessItems
            current={outgoingDocumentListPageIndex + 1}
            total={outgoingDocumentListTotalCount}
            hideOnSinglePage={true}
          />
        </TableFooterActionWrapper>
      </DocumentsLayout>
    </TrucWrapper>
  )
}

ConnectedDocumentOutgoingDocPage.propTypes = {}

export default withRouter(
  inject(
    'connectedDocumentStore',
    'loadingAnimationStore',
    'bookStore',
    'authorityStore',
    'authenticationStore'
  )(observer(ConnectedDocumentOutgoingDocPage))
)
